
const getInfo = (type) => {
  if (!window.location.search.split('?')[1]) {
    return undefined
  }
  let paramArr = window.location.search.split('?')[1].split('&');
  for (let i = 0; i < paramArr.length; i++) {
    if (paramArr[i].toLocaleLowerCase().indexOf(type) !== -1) {
      return paramArr[i].split('=')[1];
    }
  }
}
let temp = getInfo('token');
export default (token = temp ? temp : '', action) => {
  switch (action.type) {
    case 'SETTOKEN':
      return action.payload
    default:
      return token
  }
}
